import * as React from 'react';
import { FC } from 'react';

import { StyledTextarea } from './styled';
import { ITextareaInputProps } from './types';

/**
 * A styled textarea
 *
 * @deprecated Use TextArea from '@rbilabs/components-library' instead
 */
const TextareaInput: FC<ITextareaInputProps> = ({ ...props }) => {
  return <StyledTextarea {...props} />;
};

export default TextareaInput;
